import { isSpanishLetter } from "../domain/normalization";
import type { InputIntent } from "../domain/types";

export class DesktopInputController {
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    if (
      event.repeat ||
      event.isComposing ||
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      !isSpanishLetter(event.key)
    ) {
      return;
    }
    event.preventDefault();
    this.dispatch({ type: "letter", value: event.key });
  };

  constructor(private readonly dispatch: (intent: InputIntent) => void) {
    window.addEventListener("keydown", this.onKeyDown);
  }

  dispose(): void {
    window.removeEventListener("keydown", this.onKeyDown);
  }
}
